/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import State from "../../components/State";

const AdminState = (props) => {
    return (
        <State moduleType={'Admin'} {...props} />
    )
}

export default AdminState